// extracted by mini-css-extract-plugin
export default {"cta":"gH-z","disabled":"hH-z"};